import actionTypes from './actionTypes';

const INITIAL_STATE = {
  userInvoicesLoading: false,
  userInvoicesFailed: false,
  userInvoicesError: false,
  userInvoicesMessage: null,
  userInvoicesList: [],
  userInvoices: {},

  temporarySaveInvoiceLoading: false,
  temporarySaveInvoiceFailed: false,
  temporarySaveInvoiceError: false,
  temporarySaveInvoiceMessage: null,

  finalSaveInvoiceLoading: false,
  finalSaveInvoiceFailed: false,
  finalSaveInvoiceError: false,
  finalSaveInvoiceMessage: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ALL_USER_INVOICES_LOADING: {
      return {
        ...state,
        userInvoicesLoading: true,
        userInvoicesFailed: false,
        userInvoicesError: false,
        userInvoicesMessage: null,
        userInvoicesList: [],
        userInvoices: {}
      };
    }
    case actionTypes.FETCH_ALL_USER_INVOICES_SUCCESS: {
      return {
        ...state,
        userInvoicesLoading: false,
        userInvoicesFailed: false,
        userInvoicesError: false,
        userInvoicesMessage: null,
        userInvoicesList: [...action.payload.invoices],
        userInvoices: { ...action.payload }
      };
    }
    case actionTypes.FETCH_ALL_USER_INVOICES_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        userInvoicesLoading: false,
        userInvoicesFailed: true,
        userInvoicesError: false,
        userInvoicesMessage: message,
        userInvoicesList: [],
        userInvoices: {}
      };
    }
    case actionTypes.FETCH_ALL_USER_INVOICES_REJECT: {
      return {
        ...state,
        userInvoicesLoading: false,
        userInvoicesFailed: false,
        userInvoicesError: true,
        userInvoicesMessage: null,
        userInvoicesList: [],
        userInvoices: {}
      };
    }

    case actionTypes.TEMPORARY_SAVE_INVOICE_LOADING:
      return {
        ...state,
        temporarySaveInvoiceLoading: true,
        temporarySaveInvoiceFailed: false,
        temporarySaveInvoiceError: false,
        temporarySaveInvoiceMessage: null
      };

    case actionTypes.TEMPORARY_SAVE_INVOICE_SUCCESS:
      return {
        ...state,
        temporarySaveInvoiceLoading: false,
        temporarySaveInvoiceFailed: false,
        temporarySaveInvoiceError: false,
        temporarySaveInvoiceMessage: null
      };
    case actionTypes.TEMPORARY_SAVE_INVOICE_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        temporarySaveInvoiceLoading: false,
        temporarySaveInvoiceFailed: true,
        temporarySaveInvoiceError: false,
        temporarySaveInvoiceMessage: message
      };
    }
    case actionTypes.TEMPORARY_SAVE_INVOICE_ERROR: {
      return {
        ...state,
        temporarySaveInvoiceLoading: false,
        temporarySaveInvoiceFailed: false,
        temporarySaveInvoiceError: true,
        temporarySaveInvoiceMessage: null
      };
    }

    case actionTypes.FINAL_SAVE_INVOICE_LOADING:
      return {
        ...state,
        finalSaveInvoiceLoading: true,
        finalSaveInvoiceFailed: false,
        finalSaveInvoiceError: false,
        finalSaveInvoiceMessage: null
      };

    case actionTypes.FINAL_SAVE_INVOICE_SUCCESS:
      return {
        ...state,
        finalSaveInvoiceLoading: false,
        finalSaveInvoiceFailed: false,
        finalSaveInvoiceError: false,
        finalSaveInvoiceMessage: null
      };
    case actionTypes.FINAL_SAVE_INVOICE_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        finalSaveInvoiceLoading: false,
        finalSaveInvoiceFailed: true,
        finalSaveInvoiceError: false,
        finalSaveInvoiceMessage: message
      };
    }
    case actionTypes.FINAL_SAVE_INVOICE_ERROR: {
      return {
        ...state,
        finalSaveInvoiceLoading: false,
        finalSaveInvoiceFailed: false,
        finalSaveInvoiceError: true,
        finalSaveInvoiceMessage: null
      };
    }

    default:
      return state;
  }
};
